import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { AcceptComponent } from './authentication/accept/accept.component';
import { ChangePasswordComponent } from './authentication/change-password/change-password.component';
import { AuthGuard } from './auth.guard';
import { UpdatePasswordComponent } from './authentication/update-password/update-password.component';
import { PrivacyComponent } from './authentication/privacy/privacy.component';
import { ConsentComponent } from './authentication/consent/consent.component';
import { LegalDocumentComponent } from './authentication/legal/legal-document.component';
import { LegalOverviewComponent } from './authentication/legal/legal-overview.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'register', redirectTo: 'contact', pathMatch: 'full'
  },
  {
    path: 'contact', component: RegisterComponent
  },
  {
    path: 'reset-password', component: ForgotPasswordComponent
  },
  {
    path: 'reset-password/change', component: ChangePasswordComponent
  },
  {
    path: 'update-password', component: UpdatePasswordComponent
  },
  {
    path: 'invitations/accept', component: AcceptComponent
  },
  {
    path: 'privacy', component: PrivacyComponent
  },
  {
    path: 'terms', component: LegalDocumentComponent, data: { docType: 'terms_of_use', titleKey: 'legalPages.terms' }
  },
  {
    path: 'imprint', component: LegalDocumentComponent, data: { docType: 'imprint', titleKey: 'legalPages.imprint' }
  },
  {
    path: 'participant-info', component: LegalDocumentComponent, data: { docType: 'participant_info', titleKey: 'legalPages.participantInfo' }
  },
  {
    path: 'legal', component: LegalOverviewComponent
  },
  {
    path: 'consent', component: ConsentComponent, canActivate: [AuthGuard]
  },
   {
    path: '',
    component: AdminComponent,

    children: [
      { path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
